import { Page, PageSkeleton, Link } from '@/components';
import { useApi } from '@/api';
import {
  Flex,
  KpiSkeleton,
  ChartSkeleton,
  LinkWrapper,
  KpiCard
} from '@blockanalitica/ui';
import LiquidationsTable from './LiquidationsTable';
import CollateralSeizedHistoricTabs from './CollateralSeizedHistoricTabs';

type LiquidationsStatsResponse = {
  number_of_liquidations: number | null;
  number_of_liquidations_change: number | null;
  number_of_liquidations_change_percentage: number | null;
  collateral_seized_usd: string | null;
  collateral_seized_usd_change: string | null;
  collateral_seized_usd_change_percentage: string | null;
  debt_repaid_usd: string | null;
  debt_repaid_usd_change: string | null;
  debt_repaid_usd_change_percentage: string | null;
};

export default function MarketPage() {
  const [data, error] = useApi<LiquidationsStatsResponse>({
    url: `/liquidations/stats/`,
    queryParams: {}
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return (
      <PageSkeleton>
        <Flex gap={['s', 'xs']} flexDirection={['column', 'row']}>
          <KpiSkeleton />
          <KpiSkeleton />
          <KpiSkeleton />
        </Flex>
        <ChartSkeleton />
      </PageSkeleton>
    );
  }
  return (
    <Page title="Liquidations">
      <Flex gap={['s', 'xs']} flexDirection={['column', 'row']}>
        <KpiCard
          title="# of Liquidations"
          data={data}
          field="number_of_liquidations"
        />
        <KpiCard
          title="Collateral Liquidated"
          data={data}
          field="collateral_seized_usd"
          options={{
            valueOptions: {
              currencyValueOptions: {
                currency: 'USD',
                notation: 'compact'
              }
            }
          }}
        />
        <KpiCard
          title="Debt Repaid"
          data={data}
          field="debt_repaid_usd"
          options={{
            valueOptions: {
              currencyValueOptions: {
                currency: 'USD',
                notation: 'compact'
              }
            }
          }}
        />
        <LinkWrapper
          to="liquidators"
          // @ts-ignore
          as={Link}
          variant="kpiCardLink">
          <KpiCard
            title="N° of liquidators"
            data={data}
            field="number_of_liquidators"
            options={{
              trend: true,
              variants: { trendCurrencyValue: 'dynamic' },
              linkArrow: true
            }}
          />
        </LinkWrapper>
      </Flex>
      <CollateralSeizedHistoricTabs />
      <LiquidationsTable />
    </Page>
  );
}
